import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Stores from "./pages/Stores";
import Restaurants from "./pages/Restaurants";
import Services from "./pages/Services";
import Movies from "./pages/Movies";
import Snacks from "./pages/Snacks";
import Bookings from "./pages/Bookings";
import Conversations from "./pages/Conversations";
import Users from "./pages/Users";
import RegisteredUsers from "./pages/RegisteredUsers";
import Settings from "./pages/Settings";
import KnowledgeBase from "./pages/KnowledgeBase";
import Layout from "./components/Layout";
import BookingDesk from "./pages/BookingDesk";
import ChatbotPage from "./pages/ChatbotPage";
import OptInConfirm from "./pages/OptInConfirm";
import "./App.css";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="animate-pulse text-lg">Loading...</div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

function AppRoutes() {
  const { user } = useAuth();
  
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/dashboard" replace /> : <Login />} />
      <Route path="/chat" element={<ChatbotPage />} />
      <Route path="/opt-in/confirm" element={<OptInConfirm />} />
      <Route path="/booking-desk/:token" element={<BookingDesk />} />
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      
      <Route element={
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      }>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/stores" element={<Stores />} />
        <Route path="/restaurants" element={<Restaurants />} />
        <Route path="/services" element={<Services />} />
        <Route path="/movies" element={<Movies />} />
        <Route path="/snacks" element={<Snacks />} />
        <Route path="/bookings" element={<Bookings />} />
        <Route path="/conversations" element={<Conversations />} />
        <Route path="/knowledge" element={<KnowledgeBase />} />
        <Route path="/users" element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <Users />
          </ProtectedRoute>
        } />
        <Route path="/registered-users" element={
          <ProtectedRoute allowedRoles={["admin", "manager"]}>
            <RegisteredUsers />
          </ProtectedRoute>
        } />
        <Route path="/settings" element={<Settings />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
